<ng-template #tpl>
  <div class="fixed inset-0 z-50 flex items-center justify-center"
       (mousedown)="$event.stopPropagation()" (touchstart)="$event.stopPropagation()">

    <div class="fixed inset-0 bg-gray-900 opacity-50 dark:bg-opacity-80">
    </div>

    <div class="relative p-4 w-full {{ getSizeClass() }} max-h-full fade-slide-in" (click)="onModalClick($event)">
      <div class="relative bg-white rounded-lg shadow dark:bg-gray-700 flex flex-col max-h-[90vh]">
        <div class="flex items-center justify-between p-4 border-b rounded-t dark:border-gray-600 border-gray-200">
          <span class="text-base font-medium text-black">
            <ng-content select="[header]"></ng-content>
          </span>

          <button type="button" (click)="close()" class="modal-close-button text-gray-400 cursor-pointer bg-transparent hover:bg-gray-200 hover:text-gray-900 rounded-lg text-sm w-8 h-8 ms-auto inline-flex justify-center items-center dark:hover:bg-gray-600 dark:hover:text-white">
            <app-icons icon="times"></app-icons>
            <span class="sr-only">Close modal</span>
          </button>
        </div>

        <div class="p-4 space-y-4 overflow-y-auto flex-1">
          <ng-content select="[body]"></ng-content>
        </div>

        <div class="p-4 border-t border-gray-200 rounded-b dark:border-gray-600 sticky bottom-0 bg-white dark:bg-gray-700 z-10">
          <ng-content select="[footer]"></ng-content>
        </div>
      </div>
    </div>
  </div>
</ng-template>
